// <div data-controller="components--modal">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import helpers from "@/utils/helpers";

export default class extends Controller {
  static targets = [ "modal" ];

  showModal() {
    this.modalTarget.style.removeProperty("display");
    // AI 채팅 패널을 닫기 위한 커스텀 이벤트 발생
    window.dispatchEvent(new CustomEvent('modal:opened'));
  }

  hideModal() {
    this.modalTarget.style.display = "none";
    // AI 채팅 FAB 버튼을 다시 표시하기 위한 커스텀 이벤트 발생
    window.dispatchEvent(new CustomEvent('modal:closed'));
  }

  connect() {
    if (this.data.get("initial-status") === "true") {
      this.showModal();
    }
  }
}